import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { yandexReachGoal } from 'cityads-v3/utils/counterUtils';
import { Offer } from 'cityads-v3/types/offers'

import CopyTextField from 'cityads-v3/components/CopyTextField/CopyTextField';
import GoogleAdsIntegrationButton from '../tools/adsIntegration/Google/IntegrationButton';
import Typography from '@mui/material/Typography';

import classes from './OfferGetLink.scss';

type GetLinkTabPanelGoogleProps = {
  finalUrl: string,
  trackingTemplate: string,
  finalUrlSuffix: string,
  offerId: Offer['id']
}

export default function GetLinkTabPanelGoogle({ finalUrl, trackingTemplate, finalUrlSuffix, offerId }: GetLinkTabPanelGoogleProps): JSX.Element {
  const { t } = useTranslation(['Offers']);

  const onCopyFinalUrl = useCallback(() => {
    yandexReachGoal('COPY_GOOGLE_FINAL_URL')
  }, [])

  return (
    <div className={classes.linkTabPanel}>
      <Typography variant="body1">
        {t('exports.googleNote')}
      </Typography>
      <CopyTextField
        copyOnFocus
        label={t('exports.finalUrl')}
        helperText={t('exports.finalUrlHelper')}
        multiline={false}
        fullWidth={true}
        value={finalUrl || ''}
        InputLabelProps={{ shrink: true }}
        FormHelperTextProps={{ className: classes.trackingInputHelper }}
        margin="normal"
        onCopyText={onCopyFinalUrl}
      />
      <CopyTextField
        copyOnFocus
        label={t('exports.trackingTemplate')}
        helperText={t('exports.trackingTemplateHelperGoogle')}
        multiline={false}
        fullWidth={true}
        value={trackingTemplate || ''}
        InputLabelProps={{ shrink: true }}
        FormHelperTextProps={{ className: classes.trackingInputHelper }}
        margin="normal"
      />
      <CopyTextField
        copyOnFocus
        label={t('exports.finalUrlSuffix')}
        helperText={t('exports.finalUrlSuffixHelperGoogle')}
        multiline={false}
        fullWidth={true}
        value={finalUrlSuffix || ''}
        InputLabelProps={{ shrink: true }}
        FormHelperTextProps={{ className: classes.trackingInputHelper }}
        margin="normal"
      />

      <hr />
      <GoogleAdsIntegrationButton offerId={offerId} />
    </div>
  );
}
